function RevenueSharing() {
  return <div>RevenueSharing</div>;
}

export default RevenueSharing;
